








import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation } from "vuex-class";

import ComplaintsForms from "@/components/falcon/complaints/ComplaintsForms.vue";
import ComplaintsTable from "@/components/falcon/complaints/ComplaintsTable.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaints view component
 */
@Component({
  components: { ComplaintsTable, ComplaintsForms },
  filters: {
    ...capitalizeFilter
  }
})
export default class ComplaintsView extends Vue {
  @Mutation("app/setTitlePrefix") private setTitlePrefix!: (
    newPrefix: string
  ) => void;
  @Watch("$i18n.locale") private localeUpdated(): void {
    this.setTranslatedTitlePrefix();
  }

  i18nMessageKeyEnum = I18nMessageKey;

  created(): void {
    this.setTranslatedTitlePrefix();
  }

  private setTranslatedTitlePrefix(): void {
    this.setTitlePrefix(
      capitalizeFilter.capitalize(
        this.$t(this.i18nMessageKeyEnum.ComplaintsModuleTitleText)
      )
    );
  }
}
